module.exports = "//public.getcloudapp.com/packs/media/images/seats-left-3da1c62bd5fad92e114d101b94b8c627.svg";